'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Policy = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Policy, _Component);

  function Policy() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Policy);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Policy.__proto__ || (0, _getPrototypeOf2.default)(Policy)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentNav: _this.props.params && _this.props.params.query || 'intro'
    }, _this.handleChangeNav = function (nav) {
      _this.setState({ currentNav: nav });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Policy, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Policy.scss');
      var currentNav = this.state.currentNav;

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Policy' }),
        _react2.default.createElement(
          _reactBootstrap.Row,
          { className: styles.policy },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 3, className: styles.policySidebar },
            _react2.default.createElement(
              'div',
              { className: styles.policySidebarItem },
              _react2.default.createElement(
                'div',
                {
                  className: styles.sidebarNav + (currentNav === 'gioi-thieu' ? ' ' + styles.active : ''),
                  onClick: function onClick() {
                    return _this2.handleChangeNav('gioi-thieu');
                  }
                },
                'Gi\u1EDBi thi\u1EC7u Lookme'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.sidebarNav + (currentNav === 'thong-tin-lien-he' ? ' ' + styles.active : ''),
                  onClick: function onClick() {
                    return _this2.handleChangeNav('thong-tin-lien-he');
                  }
                },
                'Th\xF4ng tin li\xEAn h\u1EC7'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.sidebarNav + (currentNav === 'dieu-khoan' ? ' ' + styles.active : ''),
                  onClick: function onClick() {
                    return _this2.handleChangeNav('dieu-khoan');
                  }
                },
                '\u0110i\u1EC1u kho\u1EA3n'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.sidebarNav + (currentNav === 'quy-che-hoat-dong' ? ' ' + styles.active : ''),
                  onClick: function onClick() {
                    return _this2.handleChangeNav('quy-che-hoat-dong');
                  }
                },
                'Quy ch\u1EBF ho\u1EA1t \u0111\u1ED9ng'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.sidebarNav + (currentNav === 'giai-quyet-tranh-chap' ? ' ' + styles.active : ''),
                  onClick: function onClick() {
                    return _this2.handleChangeNav('giai-quyet-tranh-chap');
                  }
                },
                'Quy tr\xECnh gi\u1EA3i quy\u1EBFt tranh ch\u1EA5p'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.sidebarNav + (currentNav === 'bao-mat' ? ' ' + styles.active : ''),
                  onClick: function onClick() {
                    return _this2.handleChangeNav('bao-mat');
                  }
                },
                'Ch\xEDnh s\xE1ch b\u1EA3o m\u1EADt'
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 9, className: styles.policyRight },
            currentNav === 'gioi-thieu' && _react2.default.createElement(_components.Intro, null),
            currentNav === 'thong-tin-lien-he' && _react2.default.createElement(_components.Contacts, null),
            currentNav === 'dieu-khoan' && _react2.default.createElement(_components.Terms, null),
            currentNav === 'bao-mat' && _react2.default.createElement(_components.Privacy, null),
            currentNav === 'quy-che-hoat-dong' && _react2.default.createElement(_components.Activity, null),
            currentNav === 'giai-quyet-tranh-chap' && _react2.default.createElement(_components.Conflit, null)
          )
        )
      );
    }
  }]);
  return Policy;
}(_react.Component), _class.propTypes = {
  params: _react.PropTypes.object
}, _temp2);
exports.default = Policy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Policy/Policy.js
// module id = 1684
// module chunks = 0